// Libraries
import React, { useState, useContext, Fragment } from 'react';

// Services and Contexts
import LanguageContext from '../contexts/LanguageContext';

// Material-UI
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import TranslateIcon from '@material-ui/icons/Translate';
import ExpandIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles((theme) => ({
  languageButton: {
    color: 'white',
    marginRight: theme.spacing(1.5),
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(3)
    }
  },
  logo: {
    width: '150px',
    [theme.breakpoints.up('sm')]: {
      width: '175px'
    }
  }
}));

export default function TopBar() {
  const { language, setLanguage, translate } = useContext(LanguageContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const styles = useStyles();

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (language) => {
    setLanguage(language);
    setAnchorEl(null);
  };

  return (
    <Fragment>
      <AppBar position="fixed">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box paddingTop="5px">
            <Toolbar>
              <Link href="/">
                <img
                  src="/images/intellisense_white_logo.svg"
                  alt="IntelliSense.io Logo"
                  className={styles.logo}
                />
              </Link>
            </Toolbar>
          </Box>

          <Box>
            <Button
              onClick={handleClick}
              aria-controls="fade-menu"
              className={styles.languageButton}
              size="small"
              disableRipple
              startIcon={<TranslateIcon />}
              endIcon={<ExpandIcon />}>
              {translate('UI_BUTTON_LANGUAGE_SELECTOR')}
            </Button>
            <Menu
              id="fade-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={() => handleClose(language)}
              TransitionComponent={Fade}>
              <MenuItem onClick={() => handleClose('en')} selected={language === 'en'}>
                English
              </MenuItem>
              <MenuItem onClick={() => handleClose('ru')} selected={language === 'ru'}>
                Pусский
              </MenuItem>
            </Menu>
          </Box>
        </Box>
      </AppBar>
      <Toolbar />
    </Fragment>
  );
}
